import Footer from '#src/components/Footer/index.js';
import Header from '#src/components/Header/index.js';
import LoginStatus from '#src/components/Header/LoginStatus';

import * as components from '../../../rows';
import {
  requireAuthentication,
  requireAuthOrProspectEmail,
} from '../../routes/guards';

export const defaultNamespace = {
  dailyBurn: {
    component: components.DailyBurn,
    guards: [requireAuthentication],
  },
  darinsTestHero: { component: components.InterpolatedString }, // We're over our limit on contentful content models, so Interpolated String uses a repurposed existing but unused type, which has this unfortunate contentTypeId that cannot be changed (as far as I can tell)
  hubAnchor: { component: components.Anchor },
  hubBeliefs: { component: components.Beliefs },
  hubBuzz: { component: components.Buzz },
  hubCallout: { component: components.Callout },
  hubComposableCallout: { component: components.ComposableCallout },
  hubCorporateProductHero: { component: components.CorporateProductHero },
  hubDidYouKnow: { component: components.DidYouKnow },
  hubDownload: { component: components.GameApps },
  hubDownloadHero: { component: components.DownloadHero },
  hubFeature: { component: components.Feature },
  hubFeaturedGames: { component: components.FeaturedGames },
  hubFeaturedGamesCarousel: { component: components.FeaturedGamesCarousel },
  hubFeaturedTestimonial: { component: components.TestimonialFeature },
  hubFinishRegistration: { component: components.FinishRegistration },
  hubGameCheckout: {
    component: components.Checkout,
    guards: [requireAuthOrProspectEmail],
  },
  hubGameDetail: { component: components.GameDetail },
  hubGameDirectory: { component: components.GameDirectory },
  hubGameExtendedDetails: { component: components.GameExtendedRules },
  hubGameForm: {
    component: components.GameForm,
    guards: [requireAuthentication],
  },
  hubGameDetailScreen: { component: components.GameDetailScreenV3 },
  hubGameDetailScreenV2: { component: components.GameDetailScreenV2 },
  hubGameRules: { component: components.GameRules },
  hubGameSchedule: { component: components.GameInfo },
  hubGetApp: { component: components.GetApp },
  hubHeaderText: { component: components.HeaderText },
  headerText: { component: components.HeaderText },
  hubHero: { component: components.Hero },
  hubHighlightedCallout: { component: components.HighlightedCallout },
  hubHighlightedRow: { component: components.HighlightedRow },
  hubHowItWorks: { component: components.HowItWorks },
  hubHowTo: { component: components.HowTo },
  hubHowToPlay: { component: components.HowToPlay },
  hubHtml: { component: components.Html },
  hubIntegrations: { component: components.Integrations },
  hubInviteFriends: { component: components.InviteFriends },
  hubJobPostings: { component: components.JobPostings },
  hubLearnMore: { component: components.LearnMore },
  hubMailSignup: { component: components.ListSignup },
  hubMembershipDetails: {
    component: components.MembershipDetails,
    guards: [requireAuthentication],
  },
  hubMembershipOffer: { component: components.MembershipOffer },
  hubMembershipRulesArchive: {
    component: components.MembershipRulesArchive,
  },
  hubMembershipRules: { component: components.MembershipRules },
  hubModalLink: { component: components.ModalLink },
  hubParagraphText: { component: components.ParagraphText },
  hubPaybetSuccess: { component: components.PaybetSuccess },
  hubPartitionedCallout: { component: components.PartitionedCallout },
  hubPlainContent: { component: components.PlainContent },
  hubSimpleCta: { component: components.SimpleCta },
  hubSimpleGameCta: { component: components.SimpleGameCta },
  hubSocialFeed: { component: components.SocialFeed },
  hubPressLogos: { component: components.PressLogos },
  hubProductHero: { component: components.ProductHero },
  hubQuestions: { component: components.Questions },
  hubResponsiveHeroImage: { component: components.ResponsiveHeroImage },
  hubSendLink: { component: () => null }, // [WBRT-1396] "Text Me The App" functionality from Branch SDK is no longer available
  hubStats: { component: components.Stats },
  hubStepGroup: { component: components.StepGroup },
  hubSvgIcon: { component: components.SvgIcon },
  hubTestimonialCarousel: { component: components.TestimonialCarousel },
  hubTestimonials: { component: components.Testimonials },
  hubUpcomingGames: { component: components.UpcomingGames },
  hubUserProfile: {
    component: components.UserProfile,
    guards: [requireAuthentication],
  },
  hubWaybetterWays: { component: components.WaybetterWay },
  hubWorksWith: { component: components.WorksWith },
  hubAbContentRenderer: { component: components.ExpandableContent }, // We're over our limit on contentful content models, so ExpandableContent uses a repurposed existing but unused type that cannot be changed.

  pageWrapper: { component: 'div' },
  mainHeader: { component: Header },
  loginStatus: { component: LoginStatus },
  mainFooter: { component: Footer },
};
